import request from "./method-type.js"
import axios from "./http"

// 电费充值 电费商品分页列表
// export const getElectriList = (data) => {
//   return request.post("hm/electric/list", data);
// };
export const getElectriList = (data) => {
  return request.post("hm/electric/page", data)
}

// 电费充值 获取电费充值说明
export const getElectriExplain = () => {
  return request.get("hm/electric/explain")
}

// 电费充值 电费商品下单
export const electriCommitOrder = (data) => {
  return request.post("hm/electric/commitOrder", data)
}

// 电费充值 充值记录
export const getElectriRecord = (data = {}) => {
  return request.post("hm/electric/record", data)
}

// 会员直充 充值记录
export const getAdProductOrder = (data = {}) => {
  return request.post("ad/adProductOrder/userOrderPage", data)
}

// 会员直充 商品列表
export const getAdProductCategory = (data = {}) => {
  return request.post(`ad/adProductCategory/categoryList`, data)
}

// 福利中心 首页 获取导航信息列表
export const getNavInfo = (data) => {
  return request.post("hm/nav/info/list", data)
}

// 福利中心 首页 获取广告信息列表
export const getAdInfo = (data) => {
  return request.post("hm/ad/info/list", data)
}

/**
 * @description 福利中心 首页 更新广告统计点击次数
 */
export const saveAdClickTotal = (data) => {
  return request.post("hm/ad/info/click/total", data)
}

/**
 * @description 福利中心 首页 获取精选推荐
 */
export const getInfoProduct = () => {
  return request.get("hm/ad/info/product/list")
}

/**
 * @description 电费充值 订单售后处理 订单异常保存
 */
export const saveServiceOrder = (data) => {
  return request.post("hm/service/order/save", data)
}

/**
 * @description 电费充值 订单售后处理 订单异常详情
 */
export const getServiceOrder = (orderNo) => {
  return request.get(`hm/service/order/detail/${orderNo}`)
}

/**
 * @description 电费充值 订单售后处理 订单异常信息撤销
 */
export const delServiceOrder = (orderNo) => {
  return request.get(`hm/service/order/revoke/${orderNo}`)
}

/**
 * @description 获取用户是否关注公众号
 */
export const getUserSubscribe = () => {
  return request.get("hm/wechat/user/subscribe")
}

/**
 * @description 获取充值提醒设置
 */
export const getRechargeRemind = () => {
  return request.get("hm/recharge/remind/get")
}

/**
 * @description 保存充值提醒设置
 * @param {Object} data 要传给后台的参数
 */
export const saveRechargeRemind = (data) => {
  return request.post("hm/recharge/remind/save", data)
}

/**
 * @description 技术支持-获取常见问题列表
 *
 */
export const getFAQList = (data) => {
  return request.post("/hm/support/faq", data)
}

/**
 * @description 技术支持-获取问题分类列表
 *
 */
export const getFAQTypeList = (data) => {
  return request.post("/hm/support/faq/typeList", data)
}

// 获取最新活动列表
export const getActivitiesList = (data) => {
  return request.post("/hm/ad/info/activity/list", data)
}

// 获取全部导航信息列表
export const getNavInfoList = (data) => {
  return request.post("/hm/nav/info/all/list", data)
}

export const openStatus = () => {
  return request.get("/hm/dist/config/user_status")
}

//用户广告标识查询
export const checkUserAdStatus = (data) => {
  return request.get(`/hm/user/ad/${data}`)
}

//用户广告标识保存
export const saveUserAdStatus = (data) => {
  return request.post(`/hm/user/ad/save`, data)
}

/*
 * @description 高德坐标转换
 * @param {object} params
 */
export const getcoordinateApi = (data) => {
  return request.post(`/hm/lbs/convert`, data)
}

//获取订单通知状态
export const getNoticeStatusApi = (data) => {
  return request.post(`/hm/recharge/remind/notice/status/get`, data)
}

//保存订单通知状态
export const saveNoticeStatusApi = (data) => {
  return request.post(`/hm/recharge/remind/notice/status/save`, data)
}

/**
 * @description 获取渠道商配置--是否开通分销
 *
 * */
export const getMerCodeStatus = (data) => {
  return request.post(`/hm/user/config`, data)
}

// @description 用ticket获取用户信息
export const getUserInfo = () => {
  return request.get("/hm/user/user_info")
}

// @description 中山证券访问活动页统计
export const zszqActivityApi = (data) => {
  return request.post("/hm/request/total/zszq/activity", data)
}

// @description 中山证券访问URL统计
export const zszqUrlApi = (data) => {
  return request.post("/hm/request/total/zszq/url", data)
}

/**
 * @description 推荐商品分页列表
 *
 * */
export const getShopePageApi = (data) => {
  return axios({
    url: `/hm/shop/put/product/page`,
    data,
    method: "POST",
  })
}

/**
 * @description 查询售后订单列表
 *
 * */
export const getServiceListApi = (data) => {
  return axios({
    url: `/hm/order/service/list`,
    data,
    method: "POST",
  })
}

/**
 * @description 我的订单列表
 *
 * */
export const getMyOrderListApi = (data) => {
  return request.post("/hm/order/my/list", data)
}

/**
 * @description 查询电费、话费、会员订单详情
 *
 * */
export const getOrderDetailApi = (data) => {
  return request.post("hm/order/my/detail", data)
}

/**
 * @description: 我的-今日运营数据
 * @return {*}
 * @use:
 */
export const getTodayOperation = () => {
  return request.get("hm/dist/config/todayTotal")
}

/**
 * @description: 获取市级列表 福利首页、商城首页城市列表
 * @return {*}
 * @use:
 */
export const getCityListApi = () => {
  return request.get("hm/common/getCityList")
}

// 获取会员分享海报
export const getVipSharePoster = (data) => {
  return request.post("hm/share/vip/get", data)
}

// 获取会员订单详情
export const getVipOrderDetail = (id) => {
  return request.get(`hm/vip/order/detail/${id}`)
}

//获取业务推广列表
export const getPromotionConfigApi = (data) => {
  return request.post(`hm/promotion/config/list`, data)
}

//用户订阅
export const submitUserSubscribeApi = (data) => {
  return request.post(`hm/provider/subscribe/user`, data)
}

//获取商城商品区域统计
export const getSupRegionAPi = (data) => {
  return request.post(`hm/shop/spu/region/total`, data)
}

//高级会员升级超级会员
export const submitUpgradeSuperAPi = (data) => {
  return request.post(`hm/vip/upgrade/super`, data)
}

//获取用户订阅信息
export const getBusinessSubscribeApi = (key) => {
  return request.get(`hm/business/subscribe/order/user/get/${key}`)
}

//用户订阅服务商订单推送
export const getBusinessSubscribeSaveApi = (data) => {
  return request.post(`hm/business/subscribe/order/user/save`, data)
}

//获取用户订阅公告信息
export const getBusinessSubscribeNoticeApi = (key) => {
  return request.get(`hm/business/subscribe/notice/user/get/${key}`)
}

//用户订阅服务商公告推送
export const saveBusinessSubscribeNoticeApi = (data) => {
  return request.post(`hm/business/subscribe/notice/user/save`,data)
}

// 取消订单 通用版
export const cancelOrderApi = (orderNo) => {
  return request.get(`/hm/order/cancel/${orderNo}`)
}

// 删除订单 通用版
export const deleteOrderApi = (orderNo) => {
  return request.delete(`/hm/order/delete/${orderNo}`)
}

//获取福利首页自定义JSON
export const getIndexJsonDataApi = (businessCode) => {
  return request.get(`hm/page/custom/get/${businessCode}`)
}

//获取福利首页预览JSON
export const getIndexPreviewJsonDataApi = (businessCode) => {
  return request.get(`hm/page/custom/preview/${businessCode}`)
}

// 更新停留时长
export const saveDurationUpdateApi = (durationId) => {
  return request.get(`hm/total/operate/duration/update/${durationId}`)
}

